<template>
  <div>
    <div class="banner" v-if="temp.coverPic">
      <img :src="imgURL + temp.coverPic.path" :alt="temp.coverPic.name" />
    </div>
    <div class="productIntro">
      <div class="productIntro__title">
        <h1>{{ temp.name }}</h1>
        <p class="year">{{ year }}年度</p>
      </div>

      <div class="productIntro__author">
        <h3>創作人</h3>
        <el-row class="productIntro__author--imgList">
          <el-col class="img" :span="colSpan" v-for="(item, index) in temp.creativePeople" :key="index">
            <img :src="imgURL + item.pic.path" :alt="item.pic.name" />
            <p class="text">{{ item.name }}</p>
          </el-col>
        </el-row>
      </div>

      <div class="productIntro__author">
        <h3>聯絡E-mail</h3>
        <el-row class="productIntro__author--emailList">
          <el-col class="" v-for="(item, index) in temp.creativePeople" :key="index">
            <div v-if="item.name && item.email" class="email">
              <p class="text">
                {{ item.name }} : <span>{{ item.email }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="productIntro__description">
        <h3>創作理念</h3>
        <p class="text" v-html="temp.creativeIdea"></p>
      </div>

      <div class="productIntro__work">
        <h3>作品圖</h3>
        <div
          class="productIntro__work--imgList d-flex flex-column justify-content-center align-items-center"
          v-for="item in temp.exhibitionsPic"
          :key="item.id"
        >
          <img :src="imgURL + item.pic.path" :alt="item.pic.name" />
        </div>
      </div>

      <div class="d-flex justify-content-center" @click="goBack">
        <button class="goBack">
          <img src="../../assets/images/graduation/productList/Group.png" alt="" />返回作品列表
        </button>
      </div>

      <div class="productIntro__other">
        <h3>其他作品</h3>

        <div class="w-100">
          <div class="d-flex justify-content-center">
            <el-row class="d-flex justify-content-center">
              <el-col class="productIntro__other--img" v-for="item in getOtherArray" :key="item.id">
                <div class="hover-effect" @click="goProductInfo(item)">
                  <img :src="imgURL + item.coverPic.path" :alt="item.coverPic.name" />
                  <div class="text">
                    <p class="more">view more</p>
                  </div>
                </div>
                <p class="name">{{ item.name }}</p>
              </el-col>
            </el-row>
          </div>
          <div class="mt-20 d-flex justify-content-between align-items-center">
            <a class="cur-pointer d-flex align-items-center" @click="works_prev()">
              <img src="@/assets/images/arrowLeft_btn.png" alt="" />
            </a>

            <div class="circle">
              <div
                class="circle__content"
                :class="{ active: num === page }"
                v-for="num in otherTotal"
                :key="num"
                @click="changeOtherArray(num)"
              ></div>
            </div>

            <a class="cur-pointer d-flex align-items-center" @click="works_next()">
              <img src="@/assets/images/arrowRight_btn.png" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      otherId: "",
      imgURL: process.env.VUE_APP_BASE_IMG_URL,
      year: this.$route.query.year,
      defaultNum: 1,
      temp: {},
      otherList: [],
      newOtherList: [],
      otherTotal: 0,
      page: 1,
    };
  },
  computed: {
    colSpan() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth > 1024) {
        return 3;
      } else {
        return 6;
      }
    },
    getOtherArray() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 1024) {
        return this.otherList.filter((item, index) => index >= (this.page - 1) * 2 && index < this.page * 2);
      } else {
        return this.otherList.filter((item, index) => index >= (this.page - 1) * 3 && index < this.page * 3);
      }
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    changeOtherArray(num) {
      this.page = num;
    },
    works_prev() {
      if (this.page == 1) {
        this.page = this.otherTotal;
      } else {
        this.page = this.page - 1;
      }
    },
    works_next() {
      if (this.page == this.otherTotal) {
        this.page = 1;
      } else {
        this.page = this.page + 1;
      }
    },
    changeImgPage(num) {
      this.defaultNum = num;
    },
    goProductInfo(item) {
      this.otherId = item.id;
      this.getProductDetailData();
    },
    getOtherList() {
      let otherQuery = {
        Id: this.$route.params.id,
        GraduateId: this.$route.query.GraduateId,
        GroupTypeId: this.$route.query.GroupTypeId,
        ItemCount: 999,
      };
      this.$api.getOtherList(otherQuery).then((res) => {
        const { code, data, count } = res.data;
        if (code === 200) {
          this.otherList = data;
          this.otherTotal = Math.ceil(count / 3);
          this.otherList.forEach((item, index) => {
            try {
              this.otherList[index].coverPic = JSON.parse(item.coverPic);
            } catch (error) {
              console.log(error);
            }
          });
        }
      });
    },
    getProductDetailData() {
      let queryId = this.otherId === "" ? this.$route.params.id : this.otherId;
      this.$api.getUnitExhibit({ id: queryId }).then((res) => {
        const { code, result } = res.data;
        if (code === 200) {
          this.temp = result;
          document.documentElement.scrollTop = 0;
          try {
            this.temp.coverPic = JSON.parse(result.coverPic);
          } catch (error) {
            console.log(error);
          }

          this.temp.creativePeople = JSON.parse(result.creativePeople);
          this.temp.creativePeople.forEach((people, index) => {
            try {
              this.temp.creativePeople[index].pic = JSON.parse(people.pic);
            } catch (error) {
              console.log(JSON.parse(JSON.stringify(error)));
            }
          });

          this.temp.exhibitionsPic = JSON.parse(result.exhibitionsPic);
          this.temp.exhibitionsPic.forEach((item, index) => {
            try {
              this.temp.exhibitionsPic[index].pic = JSON.parse(item.pic);
            } catch (error) {
              console.log(error);
            }
          });
        }
      });
    },
  },
  mounted() {
    this.getProductDetailData();
    this.getOtherList();
  },
};
</script>

<style lang='scss'>
.banner {
  background-color: #efefef;
  width: 100%;
  img {
    width: 100%;
    margin-top: 56px;
    @media (min-width: 1024px) {
      margin-top: 120px;
    }
  }
}
.productIntro {
  @media (min-width: 1024px) {
    margin-bottom: 120px;
  }
  padding: 0 18px;
  @media (min-width: 1024px) {
    padding: 0 180px;
  }

  h3 {
    margin: 0 0 12px 0;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0.005em;
    color: #ceb87f;
  }
  .text {
    margin: 0;
    color: #fff;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.025em;
  }

  &__banner {
    margin-left: 120px;
    width: 100%;
  }

  &__title {
    padding-top: 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
      margin: 0;
      font-size: 64px;
      line-height: 75px;
      background: linear-gradient(180deg, #ceb87f 0%, #fff2d0 100%);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
      @media (max-width: 1024px) {
        font-size: 28px;
        line-height: 33px;
      }
    }
    .year {
      padding: 8px 28px;
      background: #e0d2af;
      border-radius: 20px;
    }
  }

  &__description {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    @media (min-width: 1024px) {
      margin-top: 56px;
    }
  }

  &__author {
    margin-top: 40px;
    display: flex;
    flex-direction: column;

    @media (min-width: 1024px) {
      margin: 56px 0 20px 0;
    }

    h3 {
      margin: 0 0 8px 0;
      font-weight: bold;
      font-size: 24px;
      line-height: 28px;
      letter-spacing: 0.005em;
      color: #ceb87f;
    }

    &--imgList {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      .img {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        width: 10%;
        @media (max-width: 768px) {
          margin: 8px;
          width: 28%;
        }
        img {
          width: 100px;
          height: 100px;
          margin-bottom: 16px;
        }
        .text {
          text-align: center;
        }
      }
    }

    &--emailList {
      display: flex;
      flex-direction: column;
      .email {
        margin-bottom: 8px;
      }
    }
  }

  &__work {
    margin-top: 40px;
    &--imgList {
      width: 100%;
      img {
        margin-bottom: 16px;
        width: 100%;
      }
    }
  }

  .goBack {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.005em;
    padding: 4px 16px;
    color: #e0d2af;
    background: #2d2d2d;
    border: 2px solid #e0d2af;
    box-sizing: border-box;
    border-radius: 25px;
    &:hover {
      color: #2d2d2d;
      background: #e0d2af;
      transition: 0.3s;
    }
    img {
      padding-right: 12px;
      color: #2d2d2d;
    }
  }

  &__other {
    padding-bottom: 120px;
    text-align: center;

    h3 {
      margin-top: 60px;
      font-size: 64px;
      line-height: 75px;
      background: linear-gradient(180deg, #ceb87f 0%, #fff2d0 100%);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
      @media (max-width: 1024px) {
        font-size: 28px;
        line-height: 33px;
      }
    }

    img {
      padding: 0 8px;
    }

    .name {
      margin: 4px 0;
      color: #fff;
    }

    .pagination {
      padding-top: 20px;
      padding-bottom: 80px;
    }

    .circle {
      color: #fff;
      width: 100%;
      display: flex;
      justify-content: center;
      cursor: pointer;

      &__content {
        margin: 0 4px;
        width: 15px;
        height: 15px;
        border-radius: 50px;
        border: 2px solid #ceb87f;
        box-sizing: border-box;
      }

      .active {
        background: #ceb87f;
        margin: 0 4px;
        width: 15px;
        height: 15px;
      }
    }

    &--img {
      position: relative;
      padding: 0 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 12px;

      @media (min-width: 1024px) {
        height: 100%;
        margin-bottom: 40px;
        overflow: hidden;
      }
      .name {
        color: #fff;
        font-size: 16px;
        line-height: 160%;
      }

      .hover-effect {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
        width: 150px;
        height: 80px;
        @media (min-width: 1024px) {
          width: 300px;
          min-height: 160px;
        }

        img {
          -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
          transition: opacity 0.35s, transform 0.35s;
        }

        .text {
          &::before,
          &::after {
            position: absolute;
            content: "";
            opacity: 0;
          }

          &::before {
            top: 40px;
            right: 20px;
            bottom: 40px;
            left: 20px;
            border-top: 1px solid #fff;
            border-bottom: 1px solid #fff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
          }

          &::after {
            top: 15px;
            right: 50px;
            bottom: 15px;
            left: 50px;
            border-right: 1px solid #fff;
            border-left: 1px solid #fff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
            -webkit-transform-origin: 100% 0;
            transform-origin: 100% 0;
          }

          .more {
            color: #fff;
            position: absolute;
            padding: 8px 24px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -100%);
            background-color: #ceb87f;
            box-shadow: 1px 1px 3px #fff;
            border-radius: 40px;
            text-transform: none;
            opacity: 0;
          }

          p {
            -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
            transition: opacity 0.35s, transform 0.35s;
          }
        }
        @media (min-width: 1024px) {
          &:hover {
            cursor: pointer;

            img {
              filter: brightness(0.5);
              transform: scale(1.2) !important;
              transition: 0.3s;
              opacity: 0.7;
              -webkit-transform: translate3d(0, 0, 0);
              transform: translate3d(0, 0, 0);
            }

            .text {
              &::before,
              &::after {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
                transition: 0.3s;
              }

              .more {
                opacity: 1;
              }
            }

            p {
              opacity: 1;
            }

            .text::after,
            p {
              -webkit-transition-delay: 0.15s;
              transition-delay: 0.15s;
            }
          }
        }
      }
    }
  }
}
</style>